export default {
  refresh: 'Refresh',
};
